/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  CheckArchiveResponse,
  ConceptGroupResponse,
  Consultation,
  ConsultationsResponsePaginated,
  CreateNewConsultationsRequest,
  PatientCommonExpression,
  PatientDocumentsResponsePaginated,
  PatientSummaryResponse,
  PatientTreatmentResponse,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CheckArchiveResponseFromJSON,
    CheckArchiveResponseToJSON,
    ConceptGroupResponseFromJSON,
    ConceptGroupResponseToJSON,
    ConsultationFromJSON,
    ConsultationToJSON,
    ConsultationsResponsePaginatedFromJSON,
    ConsultationsResponsePaginatedToJSON,
    CreateNewConsultationsRequestFromJSON,
    CreateNewConsultationsRequestToJSON,
    PatientCommonExpressionFromJSON,
    PatientCommonExpressionToJSON,
    PatientDocumentsResponsePaginatedFromJSON,
    PatientDocumentsResponsePaginatedToJSON,
    PatientSummaryResponseFromJSON,
    PatientSummaryResponseToJSON,
    PatientTreatmentResponseFromJSON,
    PatientTreatmentResponseToJSON,
} from '../models/index';

export interface ArchiveOrRestoreEntryRequest {
    patientId: string;
    entryId: string;
}

export interface CanArchiveEntryRequest {
    patientId: string;
    entryId: string;
}

export interface CreateNewConsultationsOperationRequest {
    patientId: string;
    createNewConsultationsRequest: CreateNewConsultationsRequest;
}

export interface GetAlertExpressionsRequest {
    patientId: string;
}

export interface GetConceptByPatientAndSubstanceRequest {
    substances: Array<string>;
    patientId: string;
}

export interface GetConceptGroupByIdAndPatientRequest {
    patientId: string;
    conceptGroupId: number;
    activeDoseTimingFilter?: boolean;
}

export interface GetConceptReferentialByPatientRequest {
    patientId: string;
    aggressorFilter?: string;
}

export interface GetConsultationsRequest {
    patientId: string;
    currentConsultationsId: string;
    page?: number;
    size?: number;
    resultType?: string;
    documentType?: string;
    year?: string;
    instituteId?: string;
    healthProType?: string;
    myConsultations?: boolean;
}

export interface GetExpressionsRequest {
    patientId: string;
    sctProxyKey?: Array<string>;
    aggressorRoot?: string;
}

export interface GetExpressionsByConceptGroupAndPatientRequest {
    patientId: string;
    conceptGroupId: number;
}

export interface GetLastConsultationRequest {
    patientId: string;
}

export interface GetPatientDocumentsRequest {
    patientId: string;
    documentGroupId: number;
    currentConsultationsId: string;
    page?: number;
    size?: number;
}

export interface GetSummaryByPatientRequest {
    patientId: string;
    summaryType?: GetSummaryByPatientSummaryTypeEnum;
}

export interface GetTreatmentByPatientRequest {
    patientId: string;
}

export interface GetYearsInPatientFolderRequest {
    patientId: string;
}

/**
 * 
 */
export class FolderPatientApi extends runtime.BaseAPI {

    /**
     * Archive or Restore a specific entry in folder patient
     */
    async archiveOrRestoreEntryRaw(requestParameters: ArchiveOrRestoreEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling archiveOrRestoreEntry().'
            );
        }

        if (requestParameters['entryId'] == null) {
            throw new runtime.RequiredError(
                'entryId',
                'Required parameter "entryId" was null or undefined when calling archiveOrRestoreEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/consultations/{entry_id}`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"entry_id"}}`, encodeURIComponent(String(requestParameters['entryId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Archive or Restore a specific entry in folder patient
     */
    async archiveOrRestoreEntry(requestParameters: ArchiveOrRestoreEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.archiveOrRestoreEntryRaw(requestParameters, initOverrides);
    }

    /**
     * check if it allowed to archive a specific entry in folder patient
     */
    async canArchiveEntryRaw(requestParameters: CanArchiveEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CheckArchiveResponse>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling canArchiveEntry().'
            );
        }

        if (requestParameters['entryId'] == null) {
            throw new runtime.RequiredError(
                'entryId',
                'Required parameter "entryId" was null or undefined when calling canArchiveEntry().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/consultations/{entry_id}/check-archive`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"entry_id"}}`, encodeURIComponent(String(requestParameters['entryId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CheckArchiveResponseFromJSON(jsonValue));
    }

    /**
     * check if it allowed to archive a specific entry in folder patient
     */
    async canArchiveEntry(requestParameters: CanArchiveEntryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CheckArchiveResponse> {
        const response = await this.canArchiveEntryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new consultation for a patien
     */
    async createNewConsultationsRaw(requestParameters: CreateNewConsultationsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Consultation>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling createNewConsultations().'
            );
        }

        if (requestParameters['createNewConsultationsRequest'] == null) {
            throw new runtime.RequiredError(
                'createNewConsultationsRequest',
                'Required parameter "createNewConsultationsRequest" was null or undefined when calling createNewConsultations().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/consultations`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateNewConsultationsRequestToJSON(requestParameters['createNewConsultationsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsultationFromJSON(jsonValue));
    }

    /**
     * Create a new consultation for a patien
     */
    async createNewConsultations(requestParameters: CreateNewConsultationsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Consultation> {
        const response = await this.createNewConsultationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get alert expressions of a patient
     */
    async getAlertExpressionsRaw(requestParameters: GetAlertExpressionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PatientCommonExpression>>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getAlertExpressions().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/alert-expressions`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientCommonExpressionFromJSON));
    }

    /**
     * Get alert expressions of a patient
     */
    async getAlertExpressions(requestParameters: GetAlertExpressionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PatientCommonExpression>> {
        const response = await this.getAlertExpressionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get concept by patient and substance
     */
    async getConceptByPatientAndSubstanceRaw(requestParameters: GetConceptByPatientAndSubstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ConceptGroupResponse>>> {
        if (requestParameters['substances'] == null) {
            throw new runtime.RequiredError(
                'substances',
                'Required parameter "substances" was null or undefined when calling getConceptByPatientAndSubstance().'
            );
        }

        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getConceptByPatientAndSubstance().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['substances'] != null) {
            queryParameters['substances'] = requestParameters['substances'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/concept`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ConceptGroupResponseFromJSON));
    }

    /**
     * Get concept by patient and substance
     */
    async getConceptByPatientAndSubstance(requestParameters: GetConceptByPatientAndSubstanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ConceptGroupResponse>> {
        const response = await this.getConceptByPatientAndSubstanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get concept group data by id and patient
     */
    async getConceptGroupByIdAndPatientRaw(requestParameters: GetConceptGroupByIdAndPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConceptGroupResponse>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getConceptGroupByIdAndPatient().'
            );
        }

        if (requestParameters['conceptGroupId'] == null) {
            throw new runtime.RequiredError(
                'conceptGroupId',
                'Required parameter "conceptGroupId" was null or undefined when calling getConceptGroupByIdAndPatient().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['activeDoseTimingFilter'] != null) {
            queryParameters['activeDoseTimingFilter'] = requestParameters['activeDoseTimingFilter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/concept-group/{concept_group_id}`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"concept_group_id"}}`, encodeURIComponent(String(requestParameters['conceptGroupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConceptGroupResponseFromJSON(jsonValue));
    }

    /**
     * Get concept group data by id and patient
     */
    async getConceptGroupByIdAndPatient(requestParameters: GetConceptGroupByIdAndPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConceptGroupResponse> {
        const response = await this.getConceptGroupByIdAndPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get concept referential by patient
     */
    async getConceptReferentialByPatientRaw(requestParameters: GetConceptReferentialByPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ConceptGroupResponse>>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getConceptReferentialByPatient().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['aggressorFilter'] != null) {
            queryParameters['aggressorFilter'] = requestParameters['aggressorFilter'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/referential/concept`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ConceptGroupResponseFromJSON));
    }

    /**
     * Get concept referential by patient
     */
    async getConceptReferentialByPatient(requestParameters: GetConceptReferentialByPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ConceptGroupResponse>> {
        const response = await this.getConceptReferentialByPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get patient\'s consultations
     */
    async getConsultationsRaw(requestParameters: GetConsultationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConsultationsResponsePaginated>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getConsultations().'
            );
        }

        if (requestParameters['currentConsultationsId'] == null) {
            throw new runtime.RequiredError(
                'currentConsultationsId',
                'Required parameter "currentConsultationsId" was null or undefined when calling getConsultations().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['currentConsultationsId'] != null) {
            queryParameters['current_consultations_id'] = requestParameters['currentConsultationsId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        if (requestParameters['resultType'] != null) {
            queryParameters['result_type'] = requestParameters['resultType'];
        }

        if (requestParameters['documentType'] != null) {
            queryParameters['document_type'] = requestParameters['documentType'];
        }

        if (requestParameters['year'] != null) {
            queryParameters['year'] = requestParameters['year'];
        }

        if (requestParameters['instituteId'] != null) {
            queryParameters['institute_id'] = requestParameters['instituteId'];
        }

        if (requestParameters['healthProType'] != null) {
            queryParameters['health_pro_type'] = requestParameters['healthProType'];
        }

        if (requestParameters['myConsultations'] != null) {
            queryParameters['my_consultations'] = requestParameters['myConsultations'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/consultations`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsultationsResponsePaginatedFromJSON(jsonValue));
    }

    /**
     * Get patient\'s consultations
     */
    async getConsultations(requestParameters: GetConsultationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConsultationsResponsePaginated> {
        const response = await this.getConsultationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get expressions of a patient
     */
    async getExpressionsRaw(requestParameters: GetExpressionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PatientCommonExpression>>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getExpressions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sctProxyKey'] != null) {
            queryParameters['sct_proxy_key'] = requestParameters['sctProxyKey'];
        }

        if (requestParameters['aggressorRoot'] != null) {
            queryParameters['aggressor_root'] = requestParameters['aggressorRoot'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/expressions`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientCommonExpressionFromJSON));
    }

    /**
     * Get expressions of a patient
     */
    async getExpressions(requestParameters: GetExpressionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PatientCommonExpression>> {
        const response = await this.getExpressionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get expressions by concept group and patient
     */
    async getExpressionsByConceptGroupAndPatientRaw(requestParameters: GetExpressionsByConceptGroupAndPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PatientCommonExpression>>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getExpressionsByConceptGroupAndPatient().'
            );
        }

        if (requestParameters['conceptGroupId'] == null) {
            throw new runtime.RequiredError(
                'conceptGroupId',
                'Required parameter "conceptGroupId" was null or undefined when calling getExpressionsByConceptGroupAndPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/concept-group/{concept_group_id}/expressions`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))).replace(`{${"concept_group_id"}}`, encodeURIComponent(String(requestParameters['conceptGroupId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientCommonExpressionFromJSON));
    }

    /**
     * Get expressions by concept group and patient
     */
    async getExpressionsByConceptGroupAndPatient(requestParameters: GetExpressionsByConceptGroupAndPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PatientCommonExpression>> {
        const response = await this.getExpressionsByConceptGroupAndPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get last consultations of a patient
     */
    async getLastConsultationRaw(requestParameters: GetLastConsultationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Consultation>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getLastConsultation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/last-consultations`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConsultationFromJSON(jsonValue));
    }

    /**
     * Get last consultations of a patient
     */
    async getLastConsultation(requestParameters: GetLastConsultationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Consultation> {
        const response = await this.getLastConsultationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get documents of a patient
     */
    async getPatientDocumentsRaw(requestParameters: GetPatientDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PatientDocumentsResponsePaginated>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getPatientDocuments().'
            );
        }

        if (requestParameters['documentGroupId'] == null) {
            throw new runtime.RequiredError(
                'documentGroupId',
                'Required parameter "documentGroupId" was null or undefined when calling getPatientDocuments().'
            );
        }

        if (requestParameters['currentConsultationsId'] == null) {
            throw new runtime.RequiredError(
                'currentConsultationsId',
                'Required parameter "currentConsultationsId" was null or undefined when calling getPatientDocuments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['documentGroupId'] != null) {
            queryParameters['document_group_id'] = requestParameters['documentGroupId'];
        }

        if (requestParameters['currentConsultationsId'] != null) {
            queryParameters['current_consultations_id'] = requestParameters['currentConsultationsId'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['size'] != null) {
            queryParameters['size'] = requestParameters['size'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/documents`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PatientDocumentsResponsePaginatedFromJSON(jsonValue));
    }

    /**
     * Get documents of a patient
     */
    async getPatientDocuments(requestParameters: GetPatientDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PatientDocumentsResponsePaginated> {
        const response = await this.getPatientDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get current summary by patient and type
     */
    async getSummaryByPatientRaw(requestParameters: GetSummaryByPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PatientSummaryResponse>>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getSummaryByPatient().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['summaryType'] != null) {
            queryParameters['summaryType'] = requestParameters['summaryType'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/summary`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientSummaryResponseFromJSON));
    }

    /**
     * Get current summary by patient and type
     */
    async getSummaryByPatient(requestParameters: GetSummaryByPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PatientSummaryResponse>> {
        const response = await this.getSummaryByPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get current treatments by patient
     */
    async getTreatmentByPatientRaw(requestParameters: GetTreatmentByPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PatientTreatmentResponse>>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getTreatmentByPatient().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/treatment`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PatientTreatmentResponseFromJSON));
    }

    /**
     * Get current treatments by patient
     */
    async getTreatmentByPatient(requestParameters: GetTreatmentByPatientRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PatientTreatmentResponse>> {
        const response = await this.getTreatmentByPatientRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get years available in patient folder
     */
    async getYearsInPatientFolderRaw(requestParameters: GetYearsInPatientFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<string>>> {
        if (requestParameters['patientId'] == null) {
            throw new runtime.RequiredError(
                'patientId',
                'Required parameter "patientId" was null or undefined when calling getYearsInPatientFolder().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/patients/{patient_id}/years`.replace(`{${"patient_id"}}`, encodeURIComponent(String(requestParameters['patientId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get years available in patient folder
     */
    async getYearsInPatientFolder(requestParameters: GetYearsInPatientFolderRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<string>> {
        const response = await this.getYearsInPatientFolderRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetSummaryByPatientSummaryTypeEnum = {
    Basic: 'BASIC',
    Monitored: 'MONITORED',
    Ecosystem: 'ECOSYSTEM',
    History: 'HISTORY'
} as const;
export type GetSummaryByPatientSummaryTypeEnum = typeof GetSummaryByPatientSummaryTypeEnum[keyof typeof GetSummaryByPatientSummaryTypeEnum];
